import { connect } from 'react-redux';

import { UnlockTemplateModalContent } from './UnlockTemplateModalContent';
import { unlockTemplate } from 'api/events/events.actions';

const mapDispatchToProps = (dispatch: Function) => ({
  unlockTemplate: (eventId: string) => dispatch(unlockTemplate({ id: eventId })),
});

export const UnlockTemplateModalContentContainer = connect(null, mapDispatchToProps)(UnlockTemplateModalContent);
